import { AttachmentResponseViewModel, AttachmentViewModel } from '../../areas/citizen/common/communication/components/attachment/view-models';
import { DocumentAttachmentTableViewModel } from '../../areas/citizen/common/journal/components/attachments/table/attachment-table';
import { FileUploadResult } from './file-upload-modal-props';

export function mapToAttachmentResponseViewModel(results: FileUploadResult[]): AttachmentResponseViewModel {
  return {
    documents: results.map(result => ({
      id: result.documentId,
      documentId: result.documentId,
      title: result.title,
      name: result.fileName,
      size: formatFileSize(result.fileSize),
      sizeInBytes: result.fileSize,
      aliasId: '',
      mime: result.mimeType,
      added: new Date().toISOString(),
    } as AttachmentViewModel)),
  };
}

export function mapToDocumentAttachmentTableViewModels(results: FileUploadResult[]): DocumentAttachmentTableViewModel[] {
  return results.map(result => ({
    id: result.documentId,
    title: result.title,
    fileName: result.fileName,
    mimeType: result.mimeType,
    fileSize: result.fileSize,
    contentReference: result.blobReference,
    owner: result.owner,
    isTempFile: true,
  } as DocumentAttachmentTableViewModel));
}

function formatFileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(2)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
}
